import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const getButtonColor = SERVER_URI + '/get-button-collor';

export default {

  bindButtonColor:async function(paylaod)
  {
    return apiPost(getButtonColor,paylaod)
    
  }
};